var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVxv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.084 3.341c.872-.803 2.655.001 3.437.505l10.637 6.01.012.026 7.294 4.277 3.773-6.456-7.043 3.69-2.416-1.405 10.549-6.14c.53-.336 1.895-.906 3.102-.504 1.206.404.222 2.125-.42 2.936L17.852 27.153c-.28.699-1.023 2.096-1.76 2.096-.738 0-1.65-1.398-2.013-2.097L1.921 6.276C1.502 5.38.748 3.542 1.084 3.34zm8.3 10.817L5.276 7.701l15.846 8.805-5.114 8.804-5.199-8.805 4.275-2.515-2.43-1.426-3.27 1.593z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVxv);
export default __webpack_public_path__ + "static/media/VXV.307c73d571fdee3fd43a29e9d0f87d10.svg";
export { ForwardRef as ReactComponent };